
/* *****************************    Enums    ***************************** */

import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

export enum ReactQueryKey {
    Locations = 'SB_LOCATIONS',
    CarGroups = 'SB_CAR_GROUPS',
    Segments = 'SB_SEGMENTS',
    Categories = 'SB_CATEGORIES',
    Products = 'SB_PRODUCTS',
    Rates = 'SB_RATES',
    Ancillaries = 'SB_ANCILLARIES',
    BookingById = 'SB_BOOKING_BY_ID',
    BookingNotes = 'SB_BOOKING_NOTES',
    BookingLocations = 'SB_BOOKING_LOCATIONS',
    BookingDomains = 'SB_DOMAINS',
    BookingAcrissList = 'SB_BOOKING_ACRISS_LIST',
    BookingSippList = 'SB_BOOKING_SIPP_LIST',
    BookingSegments = 'SB_BOOKING_SEGMENTS',
    BookingCategories = 'SB_BOOKING_CATEGORIES',
    BookingProducts = 'SB_BOOKING_PRODUCTS',
    BookingRates = 'SB_BOOKING_RATES',
    BookingAncillaries = 'SB_ANCILLARIES',
    Product = 'SB_PRODUCT',
    CarGroupsByLocation = 'SB_CAR_GROUPS_BY_LOCATION',
    CarsAvailabilities = 'SB_CARS_AVAILABILITIES',
    RatePlan = 'SB_RATE_PLAN',
    Coupon = 'SB_COUPON',
    AffiliationCode = 'SB_AFFILIATION_CODE',
    Company = 'SB_COMPANY',
    RulesMailingList = 'SB_RULES_MAILING_LIST',
    Customers = 'SB_CUSTOMERS',
    BookingAttachments = 'SB_BOOKING_ATTACHMENTS',
    VehiclePlates = 'SB_VEHICLE_PLATES',
    TotalToBePaid = 'SB_TOTAL_TO_BE_PAID',
    SalesChannels = 'SB_SALES_CHANNELS',
    TotalHeaderDashboard = 'SB_HEADER_DASHBOARD',
    CountDisambiguationJimpiBadge = 'SB_COUNT_DISAMBIGUATION_JIMPI',
    MobilePrefixes = 'SB_MOBILE_PREFIXES',
    Provinces = 'SB_PROVINCES',
    Countries = 'SB_COUNTRIES',
    LegalForm = 'SB_LEGAL_FORM',
    SubstitutionDataById = 'SB_SUBSTITUTION_DATA_BY_ID',
    BookingAttachmentType = 'SB_BOOKING_ATTACHMENT_TYPE',
}

export enum ReactMutationKey {
    Book = 'SB_BOOK',
    Offer = 'SB_OFFER'
}

export enum BookingType {
    BOOK = 'BOOK',
    OFFER = 'OFFER'
}

export enum RentalType {
    RETAIL = 'RET',
    CORPORATE = 'COR'
}

export enum VehicleType {
    CAR = 'CAR',
    VAN = 'VAN'
}

export enum DiscountValueType {
    ABSOLUTE = 'ABSOLUTE',
    PERCENTAGE = 'PERCENTAGE'
}

export enum InvoiceType {
    PERSON = 'BKN_INVOICE_PERSON',
    VAT_NUMBER_HOLDER = 'BKN_INVOICE_VAT_NUMBER_HOLDER',
    COMPANY = 'BKN_INVOICE_COMPANY'
}

export enum RuleType {
    Pending = 'PENDING',
    StopSells = 'STOPSALES'
}

export enum RuleStatus {
    Active = 'ACTIVE',
    NotActive = 'NOACTIVE',
    OnHold = 'ONHOLD'
}

export enum CarGroupType {
    Acriss = 'ACRISS',
    Sipp = 'SIPP'
}

export enum RentalLocationType {
    Pickup = 'pickup',
    Dropoff = 'dropoff'
}

export enum AncillaryFieldType {
    Text = 'TEXT',
    Checkbox = 'CHECKBOX'
}

export enum BookingAction {
    Edit = 'EDIT',
    EditPending = 'EDIT_PENDING',
    Book = 'BOOK',
    Confirm = 'CONFIRM',
    Reject = 'REJECT',
    Cancel = 'CANCEL',
    Fail = 'FAIL',
    Available = 'AVAILABLE',
    Unavailable = 'UNAVAILABLE',
    Blacklist = 'BLACKLIST',
    AssignVehicle = 'ASSIGN_VEHICLE',
    Clone = 'CLONE',
    CreateRA = 'CREATERA',
    resendMail = 'RESENDMAIL',
    cancelNew = 'CANCEL_AND_NEW',
    hardEdit = 'HARD_EDITING',
    CreateSubstitution = 'CREATE_SUBSTITUTION',
    CreateRARecovery = 'CREATERA_RECOVERY',
    CloneVoid = 'CLONE_VOID',
    CreateRaKeyless = "CREATERA_KEYLESS",
}

export enum BookingActionStatus {
    BeEvaluated = 'DA_VALUTARE',
    BeConfirmed = 'DA_CONFERMARE',
    BeRejected = 'DA_RIFIUTARE'
}

export enum BookingEditableField {
    Vip = 'vip',
    Cig = 'cig',
    DossierNumber = 'dossierNumber',
    ReplacementPlateNumber = 'replacementPlateNumber',
    FlightNumber = 'flightNumber',
    SpecialConditionsAccepted = 'specialConditionsAccepted'
}

export enum VipType {
    No = 'NO',
    Internal = 'INTERNAL',
    External = 'EXTERNAL',
    VipCS = 'VIP_CS'
}

export enum BookingScope {
    BookingExport = 'SCOPE_BOOKING_EXPORT',
    UploadAttachment = 'SCOPE_UPLOAD_ATTACHMENTS',
    DeleteAttachment = 'SCOPE_DELETE_ATTACHMENTS',
    DownloadAttachment = 'SCOPE_DOWNLOAD_ATTACHMENTS',
    InsertNote = 'SCOPE_INSERT_NOTES',
    CreateEditRule = 'SCOPE_CREATE_EDIT_RULES',
    DeleteRule = 'SCOPE_DELETE_RULES',
    InsertBooking = 'SCOPE_BOOKING_INSERT',
    PendingList = 'SCOPE_VIEW_BOOKING_PENDING_LIST',
    SearchBookings = 'SCOPE_VIEW_BOOKING_LIST',
    SearchBookingsFromCustomer = 'SCOPE_VIEW_CUSTOMER_BOOKINGS',
    SearchBookingsFromSM = 'SCOPE_SM_REDIRECTING_FROM_SM_BOOKING_LIST',
    Booking = 'SCOPE_BOOKING',
    Rules = 'SCOPE_VIEW_RULES_LIST',
    Import = 'SCOPE_EXTERNAL_IMPORT',
    Dashboard = 'SCOPE_DASHBOARD',
    HardEditing = 'SCOPE_HARD_EDITING',
    AvailabilityOperation = 'SCOPE_AVAILABILITY_LINK_OPERATION',
    ViewAllBooking = 'SCOPE_VIEW_ALL_BOOKINGS',
    ViewLocalBooking = 'SCOPE_VIEW_LOCAL_BOOKINGS',
    EnableSalesAndMarketingScopes = "SCOPE_SM_BUSINESS_AGREEMENT",
    ViewBusinessAgreements = "SCOPE_SM_VIEW_BUSINESS_AGREEMENT_DETAIL",
    ViewRates = "SCOPE_PRC_VIEW_RATE"
}

export enum BookingStatus {
    pending = 'PENDING',
    confirmed = 'CONFIRMED',
    assigned = 'ASSIGNED',
    draft = 'DRAFT'
}

export enum BookingSubStatus {
    carSwap = 'CAR_SWAP'
}

export enum FirstInvoiceRecipient {
    COMPANY = 'COMPANY',
    CUSTOMER = 'CUSTOMER',
    PERSON = 'PERSON'
}

export enum CreditType {
    NO_CREDIT = 'NO_CREDIT',
}

export enum LegalFormCode {
    DITTA_INDIVIDUALE="I1",
    S_N_C= "I2",
    S_A_S= "I3",
    SOC_DI_FATTO= "I4",
    SPA= "I5",
    SRL= "I6",
    SOC_CONSORTILE= "I7",
    COOPERATIVE= "I8",
    ONLUS= "I9",
    SAPA= "IA",
    ENTE_PUBBLICO= "IB",
    SOCIETA_ESTERA= "IC",
    ASSOCIAZ_PROFESS= "ID",
    COMM_EREDITARIA= "IE",
    ENTE_RELIGIOSO= "IF",
    ENTE_MORALE2= "IG",
    ENTE_OSP_ASL= "IH",
    ALTRI_ENTI= "IJ",
    FONDAZIONE= "IK",
    MUTUA_ASSICURAZ= "IL",
    SOCIETA_ANONIMA= "IM",
    SOC_COOP_AZIONI= "IN",
    SOC_COOP_ILLIM= "IO",
    SOC_COOP_LIMIT= "IP",
    SOC_SEMPLICE= "IQ",
    SRLS= "IR",
    SRLCR2= "IS",
    ALTRE_FORME_GIU= "ZZ",
    SPA_01= "01",
    SRL_02= "02",
    SAA_03= "03",
    SAS_04= "04",
    SRL_E_CO_SAS_05= "05",
    SOCDIRCIVILE_07= "07",
    CO_LTD_08= "08"
}

export const COMPANY_WITHOUT_VAT_NR =
    [
        LegalFormCode.SOCIETA_ESTERA,
        LegalFormCode.ENTE_OSP_ASL,
        LegalFormCode.SOCIETA_ANONIMA,
        LegalFormCode.ONLUS,
        LegalFormCode.ALTRE_FORME_GIU,
        LegalFormCode.ENTE_PUBBLICO,
        LegalFormCode.ENTE_RELIGIOSO,
        LegalFormCode.ENTE_MORALE2,
        LegalFormCode.ALTRI_ENTI,
    ];

export enum TourOperatorWorkingStatus {
    TODO = 'TODO',
    WIP = 'WIP',
    DONE = 'DONE'
}

export enum TypeAsset {
    OTHER = 'OTHER',
    CAI_MODULO_DENUNCIA = 'CAI_MODULO_DENUNCIA',
    DENUNCIA_FURTO_SMARRIMENTO = 'DENUNCIA_FURTO_SMARRIMENTO',
    RICEVUTA_CARROATTREZZI = 'RICEVUTA_CARROATTREZZI'
}

export const ItCodeCountry = 'IT';

export const DEFAULT_VALUE_PA_ID_NUMBER = 'XXXXXX';

export enum googleAutocompleteType {
    CITIES = '(cities)',
    ADDRESSES = 'address',
    LOCALITY = 'locality',
    PROVINCE = 'administrative_area_level_2',
    LEVEL_3 = 'administrative_area_level_3',
    COUNTRY = 'country',
    POSTAL_CODE = 'postal_code',
    ROUTE = 'route',
    STREET_NUMBER = 'street_number'
}

export const MOBILITY_STORE_ALL = '0';

export enum ProductCategory {
    POA = '43'
}

export enum PaymentTiming {
    PREPAID = 1,
    PAY_ON_ARRIVAL = 2,
}

/* *****************************    Entities    ***************************** */

export type AncillarySellType = 'N' | 'A' | 'S' | 'Z' | 'B' | 'R';

export type ImportWorkingStatus = TourOperatorWorkingStatus.TODO | TourOperatorWorkingStatus.WIP | TourOperatorWorkingStatus.DONE;

export type Gender = 'M' | 'F';

export interface IOperator {
    username: string
}

export interface IBookingNote {
    creationTimestamp: string,
    creationOperator: IOperator,
    body: string
}

export interface IBookingLocation {
    id: string,
    updatedate: string | null,
    code: string | null,
    label: string,
    type: string | null,
    area: string | null,
    region: string | null,
    zone: string | null,
}

export interface IBookingAncillary {
    ancillaryCode: string,
    label: string
}

export interface IBookingPermission {
    actions: {
        [key: string]: string[]
    }
}

export interface IBookingChangelogEntry {
    datetime: string,
    operator: IOperator,
    fieldName: string,
    originalValue: string,
    newValue: string
}

export interface IBookingCarGroup {
    type: CarGroupType,
    acrissCode: string,
    sippCode: string | null,
    cargroupModel: string,
    keyless: boolean,
    carSegment: string,
    bookedVehicleType: VehicleType
}

export interface IBookingAttachment {
    id: string,
    name: string,
    contentType: string,
    size: string,
    creationDateTime: string,
    creationOperator: IOperator,
    type: TypeAsset | null
}

export interface IBooking {
    id: string,
    status: string,
    subStatus: string | null,
    bookingType: BookingType,
    salesChannel: string,
    rentalType: RentalType,
    cancellationDatetime: string,
    pickupLocation: IBookingLocation,
    dropoffLocation: IBookingLocation,
    pickupDate: string,
    pickupDateLocalISO: string,
    dropoffDate: string,
    dropoffDateLocalISO: string,
    carGroup: IBookingCarGroup,
    keyless: boolean,
    keybox: boolean,
    ancillaries: {
        code: string,
        mileage: number;
        label: string,
        units: number,
        selected: boolean,
        subtype: string,
        ancillaryCode: any,
        sellType: string,
        passageToCounterNeeded?: boolean | null
    }[],
    totalRentalDays: number,
    notes: IBookingNote[],
    discountCode: string | null,
    mileageIncluded: string,
    bookingSmProduct: string,
    rate: string,
    codeDescription: string | null,
    customerCode: string,
    cig: string,
    subscriptionNumber: string | null,
    subscriptionMonth: number,
    assignedPlateNumber: string | null,
    dossierNumber: string
    renewalNumber: string,
    renewal: boolean,
    bookingOwner: {
        customerId: string,
        name: string,
        surname: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        email: string,
        mobile: string,
        mobilePrefix: IMobilePrefix | null,
        drivingLicenseNumber: string,
    } | null,
    bookingCompanyOwner: {
        customerId: string,
        companyName: string,
        country: string,
        city: string,
        streetName: string,
        streetNumber: string,
        postalCode: string
        email: string,
        pec: string,
        telephone: string,
        mobile: string,
        mobilePrefix: IMobilePrefix | null,
        sdiCode: string,
        vatNumber: string,
        vatNumberCountry: string,
        fiscalCode: string,
        customerCode: string,
        sapId: string,
        productCode: string,
        legalEntity: ILegalEntity | null,
        publicAuthority: string | null;
        paIdNumber: string | null;
        siren: string| null;
        siret: string| null;
    } | null,
    firstDriver: {
        customerId: string,
        name: string,
        surname: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        email: string,
        mobile: string,
        drivingLicenseNumber: string,
        webCheckIn: boolean,
        gender: Gender | '',
        mobilePrefix: IMobilePrefix | null
    } | null,
    additionalDrivers: {
        customerId: string,
        name: string,
        surname: string,
        email: string,
        webCheckIn: boolean
    }[],
    invoicePerson: {
        customerId: string,
        type: InvoiceType.PERSON,
        name: string,
        surname: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        email: string,
        mobile: string,
        mobilePrefix: IMobilePrefix | null,
        drivingLicenseNumber: string,
        billingCountry: string | null,
        billingCity: string,
        billingStreetName: string,
        billingStreetNumber: string,
        billingPostalCode: string,
        pec: string,
        billingProvince: string | null
    } | null,
    invoiceCompany: {
        customerId: string,
        type: InvoiceType.COMPANY | InvoiceType.VAT_NUMBER_HOLDER,
        fiscalCode: string,
        email: string,
        billingStreetName: string,
        billingStreetNumber: string,
        billingPostalCode: string,
        billingCity: string,
        billingCountry: string,
        companyName: string,
        invoiceCode: string,
        pec: string,
        vatNumber: string,
        vatNumberCountry: string,
        billingProvince: string | null;
        legalEntity: ILegalEntity | null;
        publicAuthority: string | null;
        paIdNumber: string | null;
        siren: string| null;
        siret: string| null;
        sapId: string | null;
    } | null,
    productFirstBooking: boolean,
    unsatisfiedPendingRuleStopSale: boolean,
    externalNumber: string,
    idSmProduct: string,
    tenant: string,
    dealer: string,
    creditType: string,
    delivery: boolean,
    deliveryStreetName: string | null,
    deliveryStreetNumber: string | null,
    deliveryPostalCode: string | null,
    deliveryCity: string | null,
    deliveryState: string | null,
    collection: boolean,
    collectionStreetName: string | null,
    collectionStreetNumber: string | null,
    collectionPostalCode: string | null,
    collectionCity: string | null,
    collectionState: string | null,
    specialConditionsAccepted: boolean,
    flightNumber: string,
    replacementPlateNumber: string,
    rentalAgreement: string | null,
    totalToBePaid: number,
    blackList: boolean,
    vip: VipType,
    idVipCluster: string,
    expiredAt: string,
    userProcessing: string,
    dateProcessing: string,
    blackListDescription: string,
    /* sourceCountry: string, */
    carGroupModels: string,
    segment: string,
    category: string,
    secondCreditCardRequired: boolean,
    requestCreationDate: string,
    requestUpdateDate: string | null,
    totals: IBookingTotalDetail[]
    affiliationCode: string,
    creationOperator: IOperator,
    salesChannelCountry: string | null,
    jimpiCustomerCode: string,
    rules: IRule[],
    substitution: boolean,
    rentwayNumber: string | null,
    fastLine: boolean,
    carSwap: boolean,
    carGroupToReplace: string,
    dropoffLocationDescForReplacement: string,
    dropoffLocationForReplacement: string,
    dropoffDatetimeForReplacement: string,
    expirationDateTime: string | null,
    changelog: IBookingChangelogEntry[],
    pendingAvailability: number | null,
    idSmProductLabel: string,
    rateLabel: string,
    categoryLabel: string,
    segmentLabel: string,
    oldBookingCode: string | null,
    updateOperator: IOperator | null,
    cancellationOperator: IOperator | null,
    cancellationDateTime: string | null,
    packageSwap: boolean,
    fcaBankCardNumber: string | null,
    parentRa: string | null,
    paymentProvider: string | null,
    paymentStatus: string | null,
    paymentCode: string | null,
    paymentCodeDescription: string | null,
    greenDiscount: string | null,
    checkBlackList: boolean,
    bookingDatetime: string,
    discountOverprice: number | null,
    paymentTimingForNtw: number,
    offerId: string | null,
    customerAtDesk: boolean,
    voucherInvoiceAmount: number,
    driverInvoiceAmount: number,
    recovery: boolean,
    substitutionDetail: {
        active: boolean,
        reason: string,
        eventDate: string,
        eventPlaceCountry: string,
        eventPlaceCity: string,
        eventPlaceProvince: string,
        eventPlacePostalCode: string,
        eventPlaceStreetName: string,
        eventPlaceStreetNumber: string,
        eventDescription: string,
        vehicleAvailability: boolean,
        policeInvolved: boolean,
        notePoliceInvolved: string,
        substancesInfluence: boolean,
        dropoffDate: string,
        dropoffLocation: IBookingLocation,
        creationOperator: IOperator,
        updateOperator:IOperator
    }
    pendingAction: string | null
}

export interface IAncillaryField {
    code: string,
    sortKey: number,
    meta: {
        type: AncillaryFieldType,
        [key: string]: any
    },
}

export interface IWeeklyTimeRanges {
    mon: [number, number][],
    tue: [number, number][],
    wed: [number, number][],
    thu: [number, number][],
    fri: [number, number][],
    sat: [number, number][],
    sun: [number, number][]
}

export interface IWeeklyTimeRangesStringified {
    mon: string,
    tue: string,
    wed: string,
    thu: string,
    fri: string
    sat: string
    sun: string
}

export interface ILocation {
    id: string,
    updatedate: string,
    code: string,
    label: string,
    openings: IWeeklyTimeRangesStringified,
    afterHours: boolean,
    keybox: boolean,
    area: string,
    region: string,
    zone: string,
    ntwId: number,
    specialDayOpenings: {
        date: string,
        timeframes: string
    }[]
}

export interface IBookingTotalDetail {
    description: string,
    amount: number,
    subrow: boolean,
    currency: string,
    codeTypeTotal: string,
    originalAmount: number
}

export interface IRule {
    id: number,
    type: RuleType,
    name: string,
    creationOperator: IOperator,
    startDateTime: string,
    endDateTime: string | null,
    skip: number,
    skipCounter?: number,
    applyFor: number | null,
    applyForCounter?: number,
    mailingList: string[],
    alertOnSetting: boolean,
    alertOnActivation: boolean,
    pickupDateTimeFrom: string | null,
    excludedPickupDateTimeFrom: boolean,
    pickupDateTimeTo: string | null,
    excludedPickupDateTimeTo: boolean,
    dropoffDateTimeFrom: string | null,
    excludedDropoffDateTimeFrom: boolean,
    dropoffDateTimeTo: string | null,
    excludedDropoffDateTimeTo: boolean,
    includingDateTimeFrom: string | null,
    excludedIncludingDateTimeFrom: boolean,
    includingDateTimeTo: string | null,
    excludedIncludingDateTimeTo: boolean,
    pickupLocations: string[],
    excludedPickupLocations: boolean,
    dropoffLocations: string[],
    excludedDropoffLocations: boolean,
    pickupAreas: string[],
    excludedPickupAreas: boolean,
    dropoffAreas: string[],
    excludedDropoffAreas: boolean,
    pickupRegions: string[],
    excludedPickupRegions: boolean,
    dropoffRegions: string[],
    excludedDropoffRegions: boolean,
    pickupZones: string[],
    excludedPickupZones: boolean,
    dropoffZones: string[],
    excludedDropoffZones: boolean,
    acrissList: string[],
    excludedAcrissList: boolean,
    sippList: string[],
    excludedSippList: boolean,
    customerCodes: string[],
    excludedCustomerCodes: boolean,
    salesChannels: string[],
    excludedSalesChannels: boolean,
    segments: string[],
    excludedSegments: boolean,
    categories: string[],
    excludedCategories: boolean,
    products: string[],
    excludedProducts: boolean,
    rates: string[],
    excludedRates: boolean,
    ancillaries: string[],
    excludedAncillaries: boolean,
    minDuration: number | null,
    excludedMinDuration: boolean,
    maxDuration: number | null,
    excludedMaxDuration: boolean,
    minNoticeDays: number | null,
    excludedMinNoticeDays: boolean,
    maxNoticeHours: number | null
    excludedMaxNoticeHours: boolean
    tenants: string[],
    dealers: string[],
}

export interface ICarGroup {
    acrissCode: string,
    sippCode: string,
    type: CarGroupType,
    acrissLabel: string,
    sippLabel: string,
    keyless: boolean,
    carSegment: string,
    bookedVehicleType: VehicleType,
    cargroupModel?: string
}

export interface IRate {
    code: string,
    label: string
}

export interface ILegalEntity {
    code: LegalFormCode,
    label: string
}

export interface ICustomer {
    customerId: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    birthNation: string,
    birthPlace: string,
    residenceCountry: string,
    fiscalCode: string,
    siren: string,
    siret: string,
    email: string,
    mobile: string,
    drivingLicenseNumber: string,
    billingCountry: string;
    billingProvince: string;
    billingCity: string;
    billingStreetName: string;
    billingStreetNumber: string;
    billingPostalCode: string;
    certifiedEmail: string;
    uuid: string,
    mobilePrefix: string,
    vatNumber: string,
    vatNumberCountry: string,
    invoiceCode: string,
    gender: Gender | '',
    companyName: string | null;
    telephone: string | null;
    linkedToBusinessAgreement: boolean;
    legalEntity: ILegalEntity | null;
    publicAuthority: string | null;
    paIdNumber: string | null;
}

export interface IProduct {
    code: string,
    label: string,
    category: {
        code: string,
        label: string
    },
    creditType: string,
    paymentTiming: number
}

export interface IMobilePrefix {
    country: string,
    prefix: string
}

export interface MultilanguageName extends PartialRecord<string, string>  {
    defaultLabel: string,
    en: string,
    it: string,
    fr: string
}

export type UseCustomQueryOptions<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey
> = Omit<UseQueryOptions<
    TQueryFnData,
    TError,
    TData,
    TQueryKey
>, 'queryKey' | 'queryFn'>

/* *****************************    Utils    ***************************** */

export type Nullable<T> = T | null;
export interface I18nLabel {
    [key: string]: string,
    it: string,
    en: string,
    fr: string
}

export type DeepNullUndefined<T> = T extends (string | boolean | number) ? (T | null | undefined) : T extends (infer E)[] ? DeepNullUndefined<E>[] | null | undefined : { [K in keyof T]: DeepNullUndefined<T[K]> | null | undefined } | null | undefined

export interface IBooleanOption {
    value: boolean,
    label: 'Yes' | 'No'
}

export interface IVehicleTypeOption {
    code: VehicleType,
    label: 'Car' | 'Van'
}

export interface IBasicOption {
    code: string,
    label: string
}

export type PartialRecord<K extends string | number | symbol, T> = {
    [P in K]?: T;
}

export interface RouteParams extends Record<string, string> {
    id: string
}

export interface IMultiTenant {
    tenant: string,
    dealer: string
}